import { ClientWebEmbeddingMessageType } from '@cp/common/clientWebEmbedding';
import React from 'react';
import { IEmbeddingMessagesTriggerProps } from '../types';

export const useReadyMessageTriggers = ({ isInited, postMessage }: IEmbeddingMessagesTriggerProps) => {
  React.useEffect(() => {
    if (isInited) {
      postMessage({ type: ClientWebEmbeddingMessageType.Ready });
    }
  }, [isInited, postMessage]);
};
